/**
 * This enum has predefined instance identifiers for filters-group.
 * This is used in case you have filters-group inside a component.
 * This component can exist on multiple pages - meaning on multiple routes as well.
 * If you had same ids for filters-group - it would be confused on where to apply the settings of filters-group.
 * It's safe to assume that page is going to have less than 100 original filters-groups, so we start from 100.
 * TL;DR - this is to avoid situations when we have filters-group with the same ids on page that uses components that have filters-group.
 * TL;DR - To avoid both page or a couple of components having id 0 for example, the calculated hash in this case would be the same and we don't want that.
 */
export enum FitlersGroupPredefinedInstanceIdentifier {
	ReplenishmentTable = 100,
}
